import type { AxiosRequestConfig } from 'axios'
import axios from 'axios'
import type {
  FetchDeviceFilters,
  FetchDevicePageOptions,
  PageResult,
} from '@/api/definition'
import { samApiClient } from '@/api/index'
import type { Device } from '@/pages/Device/Device'

export async function fetchDevicePageApi(
  {
    inService,
    durationTestStatus,
    transferStatus,
    selfTest,
  }: FetchDeviceFilters,
  {
    pageIndex,
    pageSize,
    sortBy,
    globalFilter,
    selectedFilters,
  }: FetchDevicePageOptions,
  pickTestProgress?: boolean,
): Promise<PageResult<Device[]>> {
  let filters: string[][] = []

  // Handle selectedFilters
  for (const name in selectedFilters) {
    filters = [
      ...filters,
      ...Object.keys(selectedFilters[name]).map((key) => [name, key]),
    ]
  }

  // Handle durationTestStatus
  for (const key in durationTestStatus) {
    const status: string = durationTestStatus[key].toString()
    filters = [
      ...filters,
      ...Object.keys(status).map(() => ['duration_test_status', status]),
    ]
  }

  // Handle transferStatus
  for (const key in transferStatus) {
    const status: string = transferStatus[key].toString()
    filters = [
      ...filters,
      ...Object.keys(status).map(() => ['transfer_status', status]),
    ]
  }

  const params = new URLSearchParams(filters)
  if (globalFilter) params.set('search', globalFilter)
  params.set('page', `${pageIndex + 1}`)
  params.set('per_page', `${pageSize}`)
  params.set('not_in_service', `${Number(!inService)}`)
  params.set('self_test', `${Number(selfTest)}`)

  if (sortBy.length > 0) {
    const [{ id, desc }] = sortBy
    params.set('sort', id)
    params.set('sort_dir', desc ? 'desc' : 'asc')
  }

  let url = `device?${params.toString()}`
  if (pickTestProgress) {
    url = `duration-test-reports?${params.toString()}`
  }

  try {
    const requestConfig: AxiosRequestConfig = {
      url: url,
      method: 'GET',
    }
    const response = await samApiClient.request<Device[]>(requestConfig)
    return {
      rowCount: Number(response.headers['x-total-count']),
      data: response.data,
    }
  } catch (e) {
    if (!axios.isCancel(e)) throw e
    return {
      rowCount: null,
      data: null,
    }
  }
}
